import * as VerdiWebClient from "verdi-web-client";
import { clearDataViewerStreamCache } from "./stream-cache-store";

let isRegistered = false;

/** Register once at app boot — stream cache must clear on org switch even when DataViewer is unmounted. */
export function registerStreamCacheSessionCleanup(): void {
    if (isRegistered) {
        return;
    }
    isRegistered = true;

    VerdiWebClient.SessionHandler.onSessionUnload.addListener(clearDataViewerStreamCache);
}
